import * as React from "react";
import { Box, Grid, Stack, Drawer, useMediaQuery, IconButton } from "@mui/material";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import GroupsRoundedIcon from "@mui/icons-material/GroupsRounded";
import EventAvailableRoundedIcon from "@mui/icons-material/EventAvailableRounded";
import PendingActionsRoundedIcon from "@mui/icons-material/PendingActionsRounded";
import EmergencyRoundedIcon from "@mui/icons-material/EmergencyRounded";

import { useTheme } from "@mui/material/styles";
import { Colors } from "../../utils/Colors";

import DoctorSidebar from "../components/DoctorSidebar";
import DoctorHeader from "../components/DoctorHeader";
import DoctorStatCard from "../components/DoctorStatCard";
import DoctorPatientCard from "../components/DoctorPatientCard";
import DoctorAppointments from "../components/DoctorAppointments";
import DoctorPrescriptions from "../components/DoctorPrescriptions";

const patients = [
  {
    id: 1,
    name: "Arjun Mehta",
    uhid: "UHID001245",
    age: 45,
    ward: "ICU-2",
    diagnosis: "Hypertension and fever",
    status: "Stable",
  },
  {
    id: 2,
    name: "Pooja Nair",
    uhid: "UHID001246",
    age: 31,
    ward: "Ward-4",
    diagnosis: "Diabetes observation",
    status: "Under Review",
  },
  {
    id: 3,
    name: "Rakesh Yadav",
    uhid: "UHID001247",
    age: 62,
    ward: "Emergency",
    diagnosis: "Cardiac chest pain",
    status: "Critical",
  },
];

export default function DoctorDashboardPage() {
  const theme = useTheme();
  const isMdDown = useMediaQuery(theme.breakpoints.down("md"));
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen((prev) => !prev);
  };

  return (
    <Box sx={{ display: "flex", minHeight: "100vh", bgcolor: Colors.bg.app }}>
      {isMdDown ? (
        <>
          <Drawer
            open={mobileOpen}
            onClose={handleDrawerToggle}
            PaperProps={{
              sx: { width: 270 },
            }}
          >
            <DoctorSidebar />
          </Drawer>

          <Box
            sx={{
              position: "fixed",
              top: 12,
              left: 12,
              zIndex: 1200,
            }}
          >
            <IconButton
              onClick={handleDrawerToggle}
              sx={{
                bgcolor: Colors.bg.paper,
                border: `1px solid ${Colors.border.light}`,
              }}
            >
              <MenuRoundedIcon sx={{ color: Colors.brand.primary }} />
            </IconButton>
          </Box>
        </>
      ) : (
        <DoctorSidebar />
      )}

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: { xs: 2, md: 3 },
        }}
      >
        <Stack spacing={2.5}>
          <DoctorHeader />

          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} lg={3}>
              <DoctorStatCard
                title="Total Patients"
                value="128"
                subtitle="Currently assigned"
                icon={<GroupsRoundedIcon />}
              />
            </Grid>

            <Grid item xs={12} sm={6} lg={3}>
              <DoctorStatCard
                title="Appointments Today"
                value="24"
                subtitle="Scheduled visits"
                icon={<EventAvailableRoundedIcon />}
                valueColor={Colors.status.info}
              />
            </Grid>

            <Grid item xs={12} sm={6} lg={3}>
              <DoctorStatCard
                title="Pending Reports"
                value="09"
                subtitle="Awaiting review"
                icon={<PendingActionsRoundedIcon />}
                valueColor={Colors.status.warning}
              />
            </Grid>

            <Grid item xs={12} sm={6} lg={3}>
              <DoctorStatCard
                title="Emergency Cases"
                value="03"
                subtitle="Need attention"
                icon={<EmergencyRoundedIcon />}
                valueColor={Colors.status.danger}
              />
            </Grid>
          </Grid>

          <Grid container spacing={2}>
            <Grid item xs={12} lg={8}>
              <Stack spacing={2}>
                {patients.map((patient) => (
                  <DoctorPatientCard key={patient.id} patient={patient} />
                ))}
              </Stack>
            </Grid>

            <Grid item xs={12} lg={4}>
              <Stack spacing={2}>
                <DoctorAppointments />
                <DoctorPrescriptions />
              </Stack>
            </Grid>
          </Grid>
        </Stack>
      </Box>
    </Box>
  );
}